import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SOLUTIONS } from "../data/config";
import { SolutionBlock } from "../components/solutions/SolutionBlock";
import { SpeakingHighlights } from "../components/solutions/SpeakingHighlights";
import { Reveal } from "../components/common/Reveal";

export default function SolutionsPage() {
  return (
    <main data-testid="solutions-page">
      <section className="bg-cream py-24 lg:py-32" data-testid="solutions-hero">
        <div className="container-site">
          <Reveal>
            <p className="eyebrow">Solutions</p>
            <h1 className="mt-4 max-w-3xl font-serif text-4xl leading-[1.08] tracking-tight text-navy sm:text-5xl lg:text-6xl">
              THE RIGHT SOLUTION STARTS WITH THE{" "}
              <span className="italic text-emerald">RIGHT QUESTION.</span>
            </h1>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-ink/75 sm:text-lg">
              Four practices, one discipline: understand the diagnosis before
              designing the intervention.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <nav className="mt-12 flex flex-wrap gap-3" aria-label="Solution pillars">
              {SOLUTIONS.map((s) => (
                <a
                  key={s.id}
                  href={`#${s.id}`}
                  data-testid={`solutions-anchor-${s.id}`}
                  className="border border-navy/15 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-navy/80 transition-colors duration-300 hover:border-gold hover:text-emerald"
                >
                  {s.letter}. {s.title}
                </a>
              ))}
            </nav>
          </Reveal>
        </div>
      </section>

      {SOLUTIONS.map((s, i) => (
        <SolutionBlock key={s.id} solution={s} index={i} />
      ))}

      <SpeakingHighlights />

      <section className="bg-navy py-20 text-cream lg:py-28" data-testid="solutions-cta-strip">
        <div className="container-site flex flex-col items-start gap-8 md:flex-row md:items-center md:justify-between">
          <Reveal>
            <p className="eyebrow">Work with us</p>
            <h2 className="mt-4 font-serif text-3xl tracking-tight sm:text-4xl">
              Have a challenge <span className="italic text-gold">worth solving?</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <Link to="/contact" className="btn-gold" data-testid="solutions-bottom-cta">
              Discuss Your Challenge <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
            </Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
